import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Accordion } from 'react-bootstrap';

// Layout
import Header from "../../components/Header";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import servicesPic1 from "../../images/services/pic1.jpg";
// import pdf from "../../images/icon/pdf.png";
// import doc from "../../images/icon/doc.png";


const ServiceDetail = (props) => {
	const contents = [
		{
			id: 'ortodoncia',
			title: '¿Cómo me ayuda una Ortodoncia?',
			description: `La ortodoncia es una especialidad odontologica que  
										ayuda a prevenir y correguir las alteraciones del desarrollo dental, las formas de las arcadas dentarias y las posicíon de los dientes, con el fin de restablecer el equilibrio funcional y estetico de los dientes mejorando tambien la estetica facial.`,
			benefits: [
				'Ortodoncia tradicional',
				'Ortodoncia lingual'
			],
			types: [
				'Brackets metalicos',
				'Brackets esteticos',
				'Brackets de autoligado'
			]
		},
		{
			id: 'endodoncia',
			title: '¿Cómo evitar una extracción dental?',
			description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book`,
			benefits: [
				'Then along come two they',
				'Thats just a little bit more than',
				'Standard dummy text ever since',
				'Simply dummy text of the printing',
				'Make a type specimen book'
			]
		},
		{
			id: 'periodoncia',
			title: '¿Tiene sangrado en las encias?',
			description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book`,
			benefits: [
				'Then along come two they',
				'Thats just a little bit more than',
				'Standard dummy text ever since',
				'Simply dummy text of the printing',
				'Make a type specimen book'
			]
		},
		{
			id: 'rehabilitacionOral',
			title: '¿Que proceso se debe seguir para una Rehabilitacion Oral?',
			description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book`,
			benefits: [
				'Then along come two they',
				'Thats just a little bit more than',
				'Standard dummy text ever since',
				'Simply dummy text of the printing',
				'Make a type specimen book'
			]
		},
		{
			id: 'esteticaDental',
			title: 'Why Medical Had Been So Popular Till',
			description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book`,
			benefits: [
				'Then along come two they',
				'Thats just a little bit more than',
				'Standard dummy text ever since',
				'Simply dummy text of the printing',
				'Make a type specimen book'
			]
		},
		{
			id: 'cirugiaDental',
			title: 'Why Medical Had Been So Popular Till',
			description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book`,
			benefits: [
				'Then along come two they',
				'Thats just a little bit more than',
				'Standard dummy text ever since',
				'Simply dummy text of the printing',
				'Make a type specimen book'
			]
		},
		{
			id: 'odontopediatria',
			title: 'Why Medical Had Been So Popular Till',
			description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book`,
			benefits: [
				'Then along come two they',
				'Thats just a little bit more than',
				'Standard dummy text ever since',
				'Simply dummy text of the printing',
				'Make a type specimen book'
			]
		},
		{
			id: 'odontologiaGeneral',
			title: 'Why Medical Had Been So Popular Till',
			description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book`,
			benefits: [
				'Then along come two they',
				'Thats just a little bit more than',
				'Standard dummy text ever since',
				'Simply dummy text of the printing',
				'Make a type specimen book'
			]
		},
		{
			id: 'implantesDentales',
			title: 'Why Medical Had Been So Popular Till',
			description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book`,
			benefits: [
				'Then along come two they',
				'Thats just a little bit more than',
				'Standard dummy text ever since',
				'Simply dummy text of the printing',
				'Make a type specimen book'
			]
		},
		{
			id: 'emergencia',
			title: 'Why Medical Had Been So Popular Till',
			description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book`,
			benefits: [
				'Then along come two they',
				'Thats just a little bit more than',
				'Standard dummy text ever since',
				'Simply dummy text of the printing',
				'Make a type specimen book'
			]
		}
	]

	const [service, setService] = useState(props.location && props.location.state && props.location.state.service ? props.location.state.service : 'ortodoncia')
	const [contentDescription, setContentDescription] = useState();

	const onServiceChange = (service) => {
		const contentInfo = contents.find(c => c.id === service);
		setContentDescription(contentInfo)
		setService(service);
	}

	useEffect(() => {
		const contentInfo = contents.find(c => c.id === service);
		setContentDescription(contentInfo)
	}, []);

	return (
		<>
			<Header />
			<div className="page-content bg-white">
				<div className="banner-wraper">
					<div className="page-banner" style={{ backgroundImage: "url(" + bnrImg1 + ")" }}>
						<div className="container">
							<div className="page-banner-entry text-center">
								<h1>Detalle de Servicio</h1>
								<nav aria-label="breadcrumb" className="breadcrumb-row">
									<ul className="breadcrumb">
										<li className="breadcrumb-item"><a href="index.html"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</a></li>
										<li className="breadcrumb-item active" aria-current="page">Detalle de Servicio</li>
									</ul>
								</nav>
							</div>
						</div>
						<img className="pt-img1 animate-wave" src={waveBlue} alt="" />
						<img className="pt-img2 animate2" src={circleDots} alt="" />
						<img className="pt-img3 animate-rotate" src={plusBlue} alt="" />
					</div>
				</div>

				<section className="section-area section-sp1">
					<div className="container">
						<div className="row">
							<div className="col-lg-8 mb-30">
								<div className="ttr-media mb-30">
									<img src={servicesPic1} className="rounded" alt="" />
								</div>
								<div className="clearfix">
									<div className="head-text mb-30">
										<h2 className="title mb-15">{contentDescription ? contentDescription.title : ''}</h2>
										<p className="mb-0">{contentDescription ? contentDescription.description : ''}</p>
									</div>
									<div className="row align-items-center">
										<div className="col-md-6 mb-30" style={{ display: "flex", flexDirection: "row", justifyContent: 'space-between', flex: 1 }}>
											<ul className="list-check-squer mb-0">
												<h3>Tipos de ortodoncia</h3>
												{contentDescription && contentDescription.benefits && contentDescription.benefits.map((b, index) => (
													<li key={index}>{b}</li>
												))
												}
											</ul>
											<ul className="list-check-squer mb-0">
												<h3>Tipos de brackets</h3>
												{contentDescription && contentDescription.types && contentDescription.types.map((b, index) => (
													<li key={index}>{b}</li>
												))
												}
											</ul>
										</div>
										{/* <div className="col-md-6 mb-30">
												<div className="skillbar-box mb-30">
													<h6 className="title">Advanced Technology</h6>
													<div className="skillbar appear">
														<p className="skillbar-bar" style={{ width: "96%" }}></p>
														<span className="skill-bar-percent">96%</span>
													</div>
												</div>
												<div className="skillbar-box mb-30">
													<h6 className="title">Certified Engineers</h6>
													<div className="skillbar appear">
														<p className="skillbar-bar" style={{ width: "79%" }}></p>
														<span className="skill-bar-percent">79%</span>
													</div>
												</div>
												<div className="skillbar-box mb-0">
													<h6 className="title">6 years Experience</h6>
													<div className="skillbar appear">
														<p className="skillbar-bar" style={{ width: "75%" }}></p>
														<span className="skill-bar-percent">75%</span>
													</div>
												</div>
											</div> */}
									</div>
								</div>
								<div className="clearfix">
									<div className="head-text mb-30">
										<h4 className="title mb-10">Preguntas Frecuentes</h4>
										<p className="mb-0">Aquí tenemos una lista de las preguntas más frecuentes con respecto a nuestros servicios e información adicional.</p>
									</div>
									<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
										<Accordion.Item eventKey="0">
											<Accordion.Header>¿Qué es la ortodoncia y para qué sirve?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">La ortodoncia mejora tu sonrisa y salud dental, corrigiendo dientes y mandíbulas mal posicionados. Una sonrisa perfecta aumenta la confianza y previene problemas futuros.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="1">
											<Accordion.Header>¿A qué edad es recomendable comenzar un tratamiento de ortodoncia?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Idealmente a los 7 años para detectar problemas temprano. Pero ofrecemos soluciones efectivas para todas las edades.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="2">
											<Accordion.Header>¿Cuánto tiempo dura un tratamiento de ortodoncia?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Generalmente de 1 a 3 años, dependiendo de cada caso. Usamos tecnología avanzada para un tratamiento eficiente y satisfactorio.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="3">
											<Accordion.Header>¿Es doloroso el tratamiento de ortodoncia?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Puede haber algo de molestia inicial, pero es manejable y temporal. Nuestros métodos modernos minimizan la incomodidad.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="4">
											<Accordion.Header>¿Qué tipos de aparatos de ortodoncia existen?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Desde brackets tradicionales hasta alineadores transparentes. Adaptamos el tratamiento a tu estilo de vida y necesidades.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="5">
											<Accordion.Header>Cómo me puedo contactar con ustedes?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</div>
							</div>
							<div className="col-lg-4">
								<aside className="sticky-top pb-1">
									<div className="widget">
										<ul className="service-menu">
											<li className={service === 'ortodoncia' ? "active" : ""} onClick={() => onServiceChange("ortodoncia")}><Link to="/service-detail"><span>Ortodoncia</span><i className="fa fa-angle-right"></i></Link></li>
											<li className={service === 'endodoncia' ? "active" : ""} onClick={() => onServiceChange("endodoncia")}><Link to="/service-detail"><span>Endodoncia</span><i className="fa fa-angle-right"></i></Link></li>
											<li className={service === 'periodoncia' ? "active" : ""} onClick={() => onServiceChange("periodoncia")}><Link to="/service-detail"><span>Periodoncia</span><i className="fa fa-angle-right"></i></Link></li>
											<li className={service === 'rehabilitacionOral' ? "active" : ""} onClick={() => onServiceChange("rehabilitacionOral")}><Link to="/service-detail"><span>Rehabilitación Oral</span><i className="fa fa-angle-right"></i></Link></li>
											<li className={service === 'esteticaDental' ? "active" : ""} onClick={() => onServiceChange("esteticaDental")}><Link to="/service-detail"><span>Estética Dental</span><i className="fa fa-angle-right"></i></Link></li>
											<li className={service === 'cirugiaDental' ? "active" : ""} onClick={() => onServiceChange("cirugiaDental")}><Link to="/service-detail"><span>Cirujía Dental</span><i className="fa fa-angle-right"></i></Link></li>
											<li className={service === 'odontoperiatria' ? "active" : ""} onClick={() => onServiceChange("odontoperiatria")}><Link to="/service-detail"><span>Odontopediatria</span><i className="fa fa-angle-right"></i></Link></li>
											<li className={service === 'odontologiaGeneral' ? "active" : ""} onClick={() => onServiceChange("odontologiaGeneral")}><Link to="/service-detail"><span>Odontologia General</span><i className="fa fa-angle-right"></i></Link></li>
											<li className={service === 'implantesDentales' ? "active" : ""} onClick={() => onServiceChange("implantesDentales")}><Link to="/service-detail"><span>Implantes Dentales</span><i className="fa fa-angle-right"></i></Link></li>
											<li className={service === 'emergencia' ? "active" : ""} onClick={() => onServiceChange("emergencia")}><Link to="/service-detail"><span>Emergencia</span><i className="fa fa-angle-right"></i></Link></li>
										</ul>
									</div>
									{/* <div className="widget">
											<div className="brochure-bx">
												<h5 className="title-head">Download</h5>
												<Link to="#" className="download-link">
													<img src={pdf} alt=""/>
													<h5 className="title">Download our Brochures</h5>
													<span>Download</span>
												</Link>
												<Link to="#" class="download-link">
													<img src={doc} alt=""/>
													<h5 className="title">Our Company Details</h5>
													<span>Download</span>
												</Link>
											</div>
										</div> */}

								</aside>
							</div>
						</div>
					</div>
				</section>

			</div>

			<Footer />

		</>
	);
}

export default ServiceDetail;